import { hubShiftsIntlIds } from './hub-shifts.ids';

export const hubShiftsLangEsMx = {
  [hubShiftsIntlIds.hubShiftsList.table.cell.header.date]: 'Fecha',
  [hubShiftsIntlIds.hubShiftsList.table.cell.header.shift]: 'Turno',
  [hubShiftsIntlIds.hubShiftsList.table.cell.header.assignRider]: 'Asignar',
  [hubShiftsIntlIds.hubShiftsList.table.cell.body.shift]:
    '{startTime} a {endTime}',

  [hubShiftsIntlIds.assignRiderToHubShiftModal.trigger.openModalButton.label]:
    'Asignar Rider',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.header.title]:
    '¿Confirmas la asignación del Rider?',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.header.closeIconButton.label]:
    'Cerrar',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.description]:
    'Al confirmar, una vacante en el <highlight>turno {shiftName}, del día {shiftDate}, de {shiftStartsAt} a {shiftEndsAt}</highlight>, será asignado automáticamente al Rider seleccionado.',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.reviewBeforeConfirming]:
    'Revisa antes de confirmar.',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.selectRider.placeholder]:
    'Selecciona o busca por ID del Rider',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.selectRider
    .label]: `ID {riderId}: {riderName} • {medal, select,
      gold {Oro}
      silver {Plata}
      bronze {Bronce}
      other {}
    } • {modality, select,
      bicycle {Bicicleta}
      motorcycle {Motocicleta}
      other {}
    }`,
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.selectRider
    .noRidersAvailable.label]: 'No Riders disponibles',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.errors.allSlotsTaken.label]:
    '<highlight>¡Período expirado!</highlight> Todas las vacantes para este período ya fueron reservadas. Para completar la asignación, elige otro turno.',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.body.errors.overlappingBooking
    .label]:
    'Esta persona ya tiene una vacante confirmada en el <highlight>turno {shiftName} ({shiftStartsAt} a {shiftEndsAt})</highlight>, que entra en conflicto con este. Elige otro turno para evitar conflictos.',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.footer.cancelButton.label]:
    'Cancelar',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.footer.confirmAndAssignButton
    .label]: 'Confirmar y asignar',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.toasts.onSuccess.title]:
    '¡Vacante asignada con éxito!',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.toasts.onSuccess.description]:
    'La persona Rider será notificada sobre el cambio',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.toasts.onError.title]:
    '¡Error al asignar la vacante!',
  [hubShiftsIntlIds.assignRiderToHubShiftModal.toasts.onError.description]:
    'Por favor, intenta nuevamente',
};
